/**
 * ExploreLightbox store — leaf module (Perf 3.1.b Step 5).
 */
import { create } from 'zustand';

const useExploreLightboxStore = create((set, get) => ({
  isOpen: false,
  item: null,
  items: [],
  // One-shot preferred OUTPUT TYPE when opening (e.g. card "Make Video"
  // opens the detail with video selected so the user can review the prompt
  // and confirm before any credits are charged).
  initialMediaType: null,
  actions: {
    openExploreLightbox: (item, items = [], options = {}) => {
      set({
        isOpen: true,
        item,
        items,
        initialMediaType: options.initialMediaType || null,
      });
    },
    closeExploreLightbox: () => {
      set({ isOpen: false, item: null, items: [], initialMediaType: null });
    },
    navigateTo: (item) => {
      set({ item });
    },
    setItems: (items) => {
      set({ items });
    },
    consumeInitialMediaType: () => {
      const value = get().initialMediaType;
      if (value != null) set({ initialMediaType: null });
      return value;
    },
  },
}));

export { useExploreLightboxStore };
export default useExploreLightboxStore;
